import classNames from "classnames";
import React, { ReactElement, useContext, useState } from "react";
import Modal from "../modal";
import { FilterModuleShowAll, MultiFilterWrapperProps } from "./filter.types";
import { FilterContext } from "./util/filterContext";

const MultiFilterWrapper = ({
  showAllMode,
  renderInputItem,
  showMoreText = "Show more filters",
  showFewerText = "Show fewer filters",
  optionsCount,
  showFewOptionsCount = 5,
}: MultiFilterWrapperProps): ReactElement => {
  const [isShowAll, setIsShowAll] = useState(false);
  const { isXsScreen } = useContext(FilterContext);
  const isShowMoreRequired = optionsCount > showFewOptionsCount && !isXsScreen;
  const toggleOptionsClassName = classNames("spark-filter-module--hide", {
    show: isShowAll,
  });

  return (
    <>
      <fieldset className="row">
        {Array.from(
          {
            length:
              optionsCount > showFewOptionsCount && !isXsScreen
                ? showFewOptionsCount
                : optionsCount,
          },
          (_, ind) => (
            <div key={ind} className="col-xs-12">
              {renderInputItem(ind)}
            </div>
          )
        )}
        {showAllMode === FilterModuleShowAll.TOGGLE && isShowMoreRequired ? (
          <div className={toggleOptionsClassName}>
            {Array.from(
              { length: optionsCount - showFewOptionsCount },
              (val, _ind) => {
                const ind = _ind + showFewOptionsCount;
                return (
                  <div key={ind} className="col-xs-12">
                    {renderInputItem(ind)}
                  </div>
                );
              }
            )}
          </div>
        ) : null}
      </fieldset>
      {showAllMode && isShowMoreRequired ? (
        <a
          tabIndex={0}
          className="spark-filter-module__show-all spark-zeta"
          onClick={(): void => setIsShowAll(!isShowAll)}
        >
          {isShowAll ? showFewerText : showMoreText}
        </a>
      ) : null}
      {showAllMode === FilterModuleShowAll.MODAL && isShowMoreRequired ? (
        <Modal
          onClose={(): void => setIsShowAll(false)}
          open={isShowAll}
          title="Add Checked Bags"
          modalFooter={<div />}
        >
          <fieldset className="row">
            {Array.from(
              { length: optionsCount - showFewOptionsCount },
              (_, _ind) => {
                const ind = _ind + showFewOptionsCount;
                return (
                  <div key={ind} className="col-md-12 col-lg-4">
                    {renderInputItem(ind)}
                  </div>
                );
              }
            )}
          </fieldset>
        </Modal>
      ) : null}
    </>
  );
};

export default MultiFilterWrapper;
